import { Outlet, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query'
import { getDatos } from '../providers/dataServer';
import Spiner from '../widgets/Spiner';
import { validarSesion } from '../providers/validarSesion';
import { customSwall } from '../components/CustomSwal';

function DashBoard() {

    const navigate = useNavigate();

    const { data, isLoading, isFetched } = useQuery(["datosTienda"], () => getDatos('/admin/getInfoAdmin'))

    if (isFetched && !!data?.ok) {
        if (data.error = 'La sesión ya no es válida o a caducado') {
            validarSesion()
        }
        if (data.ok === false) {
            validarSesion()
        }
    }

    function cerrarSession() {
        customSwall.fire({
            title: 'Cerrar Sesión',
            text: 'Deseas salir del sistema de administración?',
            icon: 'question',
            confirmButtonText: 'Cerrar Sesión',
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem('tempToken');
                window.location.reload()
            }
        });
    }

    return(
        <div className='cont-app'>
            { isLoading && <Spiner title={"Cargando..."} />}
            <div className='cont-barra-lateral'>
                <div className='cont-section-barra cont-info-user'>
                    <h1 className='titulo-administrador'>Administrador de Tienda</h1>
                    <p className='bl-nombre-admin'>Bienvenid@: {data?.datosAdmin?.nombre ?? ''} {data?.datosAdmin?.apellido ?? ''}</p>
                    <button className='btn-salir-adm' onClick={ cerrarSession }>Salir</button>
                </div>
                <div className='cont-item-bl'>
                    <div className='cont-opciones-item-bl'>
                        <button className='bl-categoria-button' onClick={ () => navigate(`/`) }>Inicio</button>
                    </div>
                </div>
                <div className='cont-item-bl'>
                    <p className='bl-divisor-title'>Administrar Productos</p>
                    <div className='cont-opciones-item-bl'>
                        {
                            data?.categorias?.map((categoria) => {
                                return <button className='bl-categoria-button' key={ categoria.id } onClick={ () => navigate(`/productos/${categoria.cod_categoria}`) } >{ categoria.nombre }</button>
                            })
                        }
                    </div>
                </div>
            </div>
            <div className='cont-section'>
                <Outlet />
            </div>
        </div>
    )
}

export default DashBoard